/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Dmitri Puscas
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface ProductPacking {
  productId: number;
  packingId: number;
  warehouseId: number;
  stock?: number;
  freeStock?: number;
}
